import { UserPointStage, UserPointStageId } from 'app/core/models';

export interface UserPointStageInfo {
  description: string;
  imgSrc: string;
}

export const UserPointStageInfo: Record<UserPointStageId, UserPointStageInfo> = {
  [UserPointStageId.Bronze]: {
    description: 'messages.userPointStageDescription.bronze',
    imgSrc: 'assets/images/user-points/bronze.svg',
  },
  [UserPointStageId.Silver]: {
    description: 'messages.userPointStageDescription.silver',
    imgSrc: 'assets/images/user-points/silver.svg',
  },
  [UserPointStageId.Gold]: {
    description: 'messages.userPointStageDescription.gold',
    imgSrc: 'assets/images/user-points/gold.svg',
  },
  [UserPointStageId.Diamond]: {
    description: 'messages.userPointStageDescription.diamond',
    imgSrc: 'assets/images/user-points/diamond.svg',
  },
};
